var watchlistPositionDelete = {
	title: "Elimina posizione",
	caption: "Posizione da eliminare",
	name: "Nome",
	alertHeading: "Sei sicuro di voler eliminare la posizione?",
	alertBody: "In caso affermativo, fare clic su Ok. Si noti che la posizione eliminata non possono essere ripristinata.",
	confirmBtn: "Ok",
	cancelBtn: "Annulla"
};
var it = {
	watchlistPositionDelete: watchlistPositionDelete
};

export { it as default, watchlistPositionDelete };
